import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { reactLocalStorage } from 'reactjs-localstorage';
import { connect } from 'react-redux';
import { WardrobeHeightContext } from '../../contexts/WardrobeHeightContext';
import { WardrobesConfigsContext } from '../../contexts/WardrobesConfigsContext';
import { ActiveWardrobeContext } from '../../contexts/ActiveWardrobeContext';
import { EventsDataContext } from '../../contexts/EventsDataContext';

const AddWardrobe = props => {
  const {
    changeBodyType,
    defaultHull,
    defaultCorner,
    wardrobeHulls,
    cornerHulls,
    defaultFront,
  } = props;

  const { wardrobeHeight } = useContext(WardrobeHeightContext);
  const { wardrobesConfigs } = useContext(WardrobesConfigsContext);
  const { activeWardrobe } = useContext(ActiveWardrobeContext);
  const { optionsVisibility, setOptionsVisibility } = useContext(EventsDataContext);

  const [state, setState] = useState({
    defaults: {
      normal: {},
      corner: {},
    },
  });

  let activeHinged = wardrobesConfigs.some(config => config.is_corner === true);

  const togglePopup = () => {
    setOptionsVisibility({ ...optionsVisibility, addWardrobe: !optionsVisibility.addWardrobe });
    optionsVisibility.addWardrobe
      ? document.body.classList.remove('overlay')
      : document.body.classList.add('overlay');
  };
  const handleClick = wardrobeType => {
    reactLocalStorage.setObject('summaryCopy', reactLocalStorage.getObject('wardrobesConfigs'));

    let wardrobeByType = state.defaults[wardrobeType];

    // wardrobeByType.id = `${wardrobeByType.id}_${Math.random()}`;
    let randomStr = Math.random().toString(36).substring(7);
    wardrobeByType.id = wardrobeByType.id.slice(0, -6) + randomStr;

    if (wardrobeByType.is_hinged && defaultFront.hasOwnProperty(8)) {
      wardrobeByType.defaultFronts = props.defaultFront[8];
      wardrobeByType.fronts = wardrobeByType.doors === 1 ? [null] : [null, null];
    } else if (defaultFront.hasOwnProperty(7)) {
      wardrobeByType.defaultFronts = props.defaultFront[7][wardrobeByType.panels];
      wardrobeByType.fronts =
        wardrobeByType.panels === 3
          ? [
              [null, null, null],
              [null, null, null],
            ]
          : [
              [null, null, null, null],
              [null, null, null, null],
            ];
    }

    changeBodyType(wardrobeType, wardrobeByType);
    setOptionsVisibility({ ...optionsVisibility, addWardrobe: !optionsVisibility.addWardrobe });
    document.body.classList.remove('overlay');
  };

  const cornerIndex = wardrobesConfigs.findIndex(config => config.is_corner === true);

  useEffect(() => {
    let lastAdd = wardrobesConfigs[activeWardrobe];
    let hullColor = lastAdd.safo.split('-').pop();

    let defaultHullInfo = defaultHull[7] ?? {
      dimensions: { x: null, y: null, z: null },
    };
    defaultHullInfo.dimensions.y = wardrobeHeight;
    if (
      wardrobesConfigs[activeWardrobe].dimensions.z === 45 &&
      wardrobesConfigs[cornerIndex] === undefined
    ) {
      defaultHullInfo.dimensions.z = 45;
    } else {
      defaultHullInfo.dimensions.z = 66;
    }

    let defaultCornerBody = cornerHulls.find(item => {
      return (
        item.types.hasOwnProperty(defaultCorner.type) &&
        item.dimensions.y === wardrobeHeight &&
        item.safo.split('-').pop() === hullColor
      );
    });

    let defaultNormalBody = wardrobeHulls.find(item => {
      return (
        item.dimensions.x === defaultHullInfo.dimensions.x &&
        item.dimensions.y === defaultHullInfo.dimensions.y &&
        item.dimensions.z === defaultHullInfo.dimensions.z &&
        item.safo.split('-').pop() === hullColor
      );
    });
    if (defaultNormalBody === undefined) {
      defaultNormalBody = wardrobeHulls.find(item => {
        return (
          item.dimensions.x === defaultHullInfo.dimensions.x &&
          item.dimensions.y === defaultHullInfo.dimensions.y &&
          item.dimensions.z === defaultHullInfo.dimensions.z
        );
      });
    }
    setState({
      defaults: {
        normal: defaultNormalBody,
        corner: defaultCornerBody,
      },
    });
    /* eslint-disable-next-line */
  }, [defaultHull, defaultCorner, wardrobeHulls, cornerHulls]);

  return (
    <div className="add-wardrobe">
      <>
        <div className="pop-up__button--possition">
          {wardrobesConfigs.length >= 5 ? null : (
            <>
              <p>Dodaj szafę</p>
              <button
                className={`pop-up__button ${optionsVisibility.addWardrobe ? 'active' : ''}`}
                onClick={togglePopup}
                title="Dodaj szafę">
                <span className="icon-plus" />
              </button>
            </>
          )}
        </div>

        <ul className={`add-wardrobe__list ${optionsVisibility.addWardrobe ? 'open' : ''}`}>
          <li className="add-wardrobe__item" onClick={() => handleClick('normal')}>
            <img
              src={`${process.env.PUBLIC_URL}/img/wardrobe-shapes/wardrobe-shape.png`}
              alt="Szafa"
            />
            <p>Szafa</p>
          </li>
          {!activeHinged && (
            <>
              <li className="add-wardrobe__item" onClick={() => handleClick('corner')}>
                <img
                  src={`${process.env.PUBLIC_URL}/img/wardrobe-shapes/corner-wardrobe-shape.png`}
                  alt="Szafa narożna"
                />
                <p>Szafa narożna</p>
              </li>
            </>
          )}
        </ul>
      </>
    </div>
  );
};

AddWardrobe.propTypes = {
  changeBodyType: PropTypes.func.isRequired,
};

const mapStateToProps = state => {
  return {
    dimensions: state.dimensions.dimensions,
    wardrobeHulls: state.products.wardrobeHulls,
    frontColorList: state.products.fronts,
    cornerHulls: state.products.cornerHulls,
    defaultHull: state.defaults.hull,
    defaultCorner: state.defaults.corner,
    defaultFront: state.defaults.front,
  };
};

export default connect(mapStateToProps, null)(AddWardrobe);
